// // intro multi lnaguage
import React, { useState, useRef, useEffect, useContext } from "react";
import { MapContainer, TileLayer, FeatureGroup, Marker, useMap } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet-control-geocoder";
import AreaDetailsSidebar from "../components/AreaDetails/AreaDetailSidebar";
import { useAnalysis } from "../contexts/AnalysisContext";
import { area as turfArea } from "@turf/turf";
import FieldData from "../components/field/FieldData";
import Modal from "../components/Modal/Modal";
import UploadImg from '../components/UploadImg/UploadImg';
import { LuUpload } from "react-icons/lu";
import AddGeocoder from "./AddGeocoder";
import { GeoJsonProvider } from "../contexts/GeoJsonContext";
import { FieldProvider } from "../contexts/FieldContext";
import 'intro.js/introjs.css'; // Importing styles for intro.js
import introJs from 'intro.js'; // Importing the main library
import TourModal from "./TourModal"; // Import modal component
// Importing intro.js for guided tour
import 'intro.js/introjs.css'; // Importing styles for intro.js
import { MessageCircleQuestion, MapPin, Loader2 } from "lucide-react";
import CurlyArrow from "../components/indicationarrow/CurlyArrow";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "../components/LanguageTranslator/LanguageContext";
import { FaTools } from "react-icons/fa"; // Maintenance icon
import { checkPageStatus } from "../utilityhook/pagecheck"; // ✅ import utility
import Swal from "sweetalert2";

const MAX_ACRES = 10;

const defaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});



L.Marker.prototype.options.icon = defaultIcon;

// Hardcoded coordinates for the polygon
const pakistanCoordinates = [33.6844, 73.0479];
const languages = [
  { value: "en", text: "English" },
  { value: "ur", text: "Urdu" },
];
const MapSelectorPage = () => {
  const [showTools, setShowTools] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const { setPolygon } = useAnalysis();
  const [areaDetails, setAreaDetails] = useState(null);
  const { toastMsg, handleCloseToast } = useAnalysis();
  const [mapCenter, setMapCenter] = useState(pakistanCoordinates); // Pakistan coordinates
  const [openImgSelecter, setOpenImgSelecter] = useState(false);
  const [newData, setNewData] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [DisableField, setDisableField] = useState(false);
  const [fieldPlan , setFieldPLan] = useState("Free");
  const { t } = useTranslation();
  const { lang, changeLanguage } = useContext(LanguageContext);
  const [isActive, setIsActive] = useState(true); // ✅ track maintenance status

  useEffect(() => {
    const fetchPageStatus = async () => {
      const active = await checkPageStatus("7-home"); // ✅ wait for backend or localStorage
      setIsActive(active);
    };
    fetchPageStatus();
  }, []);


  useEffect(() => {
    // Function to update field limit and button state
    const updateFieldLimit = () => {
      const No_Of_Fields = JSON.parse(localStorage.getItem("FieldLength")) || 0;
      const userPlan = localStorage.getItem("userPlan") || "Free";
      setFieldPLan(userPlan);
      const planLimits = {
        Free: 1,
        Diamond: 5,
        Platinum: Infinity, // No limit
      };

      const fieldsLeft =
        planLimits[userPlan] === Infinity ? "Unlimited" : Math.max(planLimits[userPlan] - No_Of_Fields, 0);


      setDisableField(fieldsLeft === 0);
    };

    // Initial call to set state
    updateFieldLimit();

    // Set interval to update every 2 seconds (adjust as needed)
    const interval = setInterval(updateFieldLimit, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);
  // State for language
  const [language, setLanguage] = useState("en");

  // Refs for intro.js
  const navigationRef = useRef(null);
  const addFieldBtnRef = useRef(null); // Reference for the Add Field button
  const polygonFunctionalityRef = useRef(null);
  const fieldOptionsRef = useRef(null);
  const languageDropdownRef = useRef(null); // Ref for dropdown


  // Language translations
  const translations = {
    en: {
      navigation: "This is the navigation sidebar where you can access various options such as delete, analyze, and update your field.",
      addField: "Click this button to add a new field to the map.",
      polygon: "Here you can draw polygons to define the boundaries of your field.",
      language: "Select a language from the dropdown.",
      options: "From fields details, you can analyze, update, or delete your field after drawing it."
    },
    ur: {
      navigation: "یہ نیویگیشن سائڈبار ہے جہاں سے آپ مختلف اختیارات تک رسائی حاصل کر سکتے ہیں جیسے حذف کرنا، تجزیہ کرنا، اور اپنے فیلڈ کو اپ ڈیٹ کرنا۔",
      addField: "نقشے میں نیا فیلڈ شامل کرنے کے لیے اس بٹن پر کلک کریں۔",
      polygon: "یہاں آپ اپنے فیلڈ کی حدود کی وضاحت کرنے کے لیے پولیگونز کھینچ سکتے ہیں۔",
      language: "ڈراپ ڈاؤن سے ایک زبان منتخب کریں۔",
      options: "یہاں آپ ڈرائنگ کے بعد اپنے فیلڈ کا تجزیہ، ریفریش یا حذف کر سکتے ہیں۔"
    }
  };


  const getSteps = (lang) => [
    {
      element: languageDropdownRef.current, // Language dropdown step
      intro: translations[lang]?.language || translations['en'].polygon,
    },

    {
      element: navigationRef.current,
      intro: translations[lang]?.navigation || translations['en'].navigation,
    },
    {
      element: addFieldBtnRef.current,
      intro: translations[lang]?.addField || translations['en'].addField,
    },
    {
      element: polygonFunctionalityRef.current,
      intro: translations[lang]?.polygon || translations['en'].polygon,
    },

    {
      element: fieldOptionsRef.current,
      intro: translations[lang]?.options || translations['en'].options,
    },
  ];


  const [steps, setSteps] = useState(getSteps(language));

  // Update steps when the language changes
  useEffect(() => {
    setSteps(getSteps(language));
  }, [language]);

  // Function to handle bounds
  const bound = (bound) => {
    if (bound && isActive) {
      setNewData(bound);
    }
  };




const handleCreated = (e) => {
  if (!isActive) return;

  const drawnPolygon = e.layer.toGeoJSON();

  const calculatedArea = turfArea(drawnPolygon); // m²
  const areaInHectares = calculatedArea * 0.0001;
  const areaInAcres = areaInHectares * 2.47105;
  console.log("this is for test", fieldPlan, areaInAcres);
  if (fieldPlan=="Diamond" || fieldPlan=="Free" ) {
    if (areaInAcres > MAX_ACRES) {
    Swal.fire({
      title: "Field area must be 10 acres or less.",
      icon: "error",
      confirmButtonText: "OK"
    })};
     // ❌ Remove invalid shape instantly
    e.target.removeLayer(e.layer);
    return; // ❌ Do not save or show sidebar
  }

  setPolygon(drawnPolygon);

  setAreaDetails({
    hectares: areaInHectares.toFixed(2),
    acres: areaInAcres.toFixed(2),
  });

  setShowSidebar(true);
};



  // Function to add new field
  const handleAddField = () => {
    if (!isActive) return;
    setShowTools(true);
    setShowSidebar(false);
  };

  // Function to get the user's location
  const handlePinPoint = () => {
    if (!isActive) return;

    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
    setLoading(true); // Start loading
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setCurrentLocation([latitude, longitude]);
        setSelectedAction("pinPoint");
        setLoading(false); // Stop loading
      },
      (error) => {
        console.error("Error getting location:", error);
        setLoading(false); // Stop loading even on error
        alert("Failed to get location.");
      }
    );
  };

  // Function to handle upload button click
  const handleUploadClick = () => {
    if (!isActive) return;
    setOpenImgSelecter(true);
  };

  // Confirmation and cancel functions
  const handleConfirm = () => {
    if (!isActive) return;
    setShowSidebar(false);
  };


  const handleCancel = () => {
    if (!isActive) return;
    setPolygon(null);
    setShowSidebar(false);
  };

  // Draw options for shapes
  const drawOptions = {
    rectangle: {
      shapeOptions: {
        color: "yellow",
        weight: 2,
        opacity: 0.8,
      },
    },
    polygon: {
      shapeOptions: {
        color: "yellow",
        weight: 2,
        opacity: 0.8,
      },
    },
  };

  // Intro.js steps enabled state
  const startTour = () => {
    if (!isActive) return;

    introJs()
      .setOptions({
        steps: steps,
        showProgress: true,
        nextLabel: 'Next',
        prevLabel: 'Back',
        doneLabel: 'Finish',
        skipLabel: 'x',
        onbeforechange: function () {
          // Logic to ensure components are ready
          const currentStepIndex = this._currentStep;
          if (!steps[currentStepIndex].element) {
            this.exit(); // Exit if the element is not available
          }
        },
        onchange: function () {
          // Focus on the next step's element
          this._scrollToElement();
        },
        oncomplete: function () {
          console.log("Tour completed!");
        },
        onexit: function () {
          console.log("Tour exited!");
        },
      })
      .start();
    setIsModalOpen(false); // Close modal when tour starts
  };

  const openVideo = () => {
    if (!isActive) return;
    window.open("/comp-guide.mp4", "_blank");
    setIsModalOpen(false); // Close modal when video is opened
  };

  // Function to handle language change
  const handleLanguageChange = (e) => {
    if (!isActive) return;
    changeLanguage(e.target.value);
  };

  // Function to handle tour modal open
  const handleTourModalOpen = () => {
    if (!isActive) return;
    setIsModalOpen(true);
  };


  return (
    <>
      <GeoJsonProvider>

        <FieldProvider>
          <div className="w-full lg:w-[96%] h-screen overflow-hidden p-2 absolute right-0">
            <div className="flex flex-col lg:flex-row gap-4 items-end justify-between lg:items-center h-full w-full">
              <div
                className="flex flex-col items-center justify-center gap-2 lg:gap-4 h-[50vh] lg:h-full w-full ml-10 lg:w-[25%]"
                ref={navigationRef} // Applying ref to the sidebar
              >
                {
                  showTools && isActive && <CurlyArrow />
                }
                <FieldData />

                <div className="flex items-center gap-4 mb-4">
                  <button
                    className="md:w-[10vw] text-sm md:text-lg 2xl:text-xl text-white bg-green-600 py-2 2xl:py-4 px-4 rounded-none lg:rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                    ref={addFieldBtnRef}
                    onClick={handleAddField}
                    disabled={DisableField || !isActive}
                  >
                    {t("Add Field")}
                  </button>
                  <div ref={languageDropdownRef}>
                    <select
                      onChange={handleLanguageChange}
                      value={lang}
                      className="md:w-[10vw] text-sm md:text-lg 2xl:text-xl text-white bg-green-600 py-2 2xl:py-4 px-4 rounded-none lg:rounded-md"
                      disabled={!isActive}
                    >
                      {languages.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.text}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <div className="flex flex-col items-center space-y-2 bg-white p-1 rounded-md shadow-md">
                      {/* Start Tour Button */}
                      <button
                        className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        data-tip="Start Tour"
                        onClick={handleTourModalOpen}
                        title="Start Tour"
                        disabled={!isActive}
                      >
                        <MessageCircleQuestion className="text-gray-700 w-4 h-4" />
                      </button>
                      {/* Modal Component */}
                      <TourModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onStartTour={startTour}
                      />

                      {/* Pin Point Button */}
                      <button
                        onClick={handlePinPoint}
                        className="flex items-center justify-center w-8 h-8 rounded-full bg-green-200 hover:bg-green-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Pin Point Location"
                        disabled={!isActive}
                      >
                        {loading ? (
                          <Loader2 className="animate-spin text-green-700 w-4 h-4" />
                        ) : (
                          <MapPin className="text-green-700 w-4 h-4" />
                        )}
                      </button>
                    </div>

                  </div>
                </div>
              </div>

              <div className="h-full w-full lg:w-[75%] overflow-hidden rounded-md shadow-md shadow-black relative">
                {/* 🚧 Under Maintenance Overlay (only visible when inactive) */}
                {!isActive && (
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 bg-opacity-90 flex flex-col items-center justify-center text-center z-[9999] backdrop-blur-sm">
                    <FaTools className="text-5xl text-green-500 mb-4 animate-bounce" />
                    <h1 className="text-3xl md:text-5xl font-semibold text-gray-600 mb-2">
                      Page Under Maintenance
                    </h1>
                    <p className="text-gray-500 text-lg max-w-md">
                      We're currently enhancing this feature for better accuracy and
                      user experience. Please check back soon!
                    </p>
                    <div className="mt-6">
                      <div className="w-16 h-16 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin mx-auto"></div>
                    </div>
                  </div>
                )}

                <div className="flex h-full w-full">
                  <MapContainer
                    center={mapCenter}
                    zoom={10}
                    className="w-full h-full"
                    id="map"
                  >
                    <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga" />
                    <AddGeocoder coordinatesArray={newData} />
                    {selectedAction === "pinPoint" && currentLocation && <Marker position={currentLocation} />}
                    <RecenterMap location={currentLocation} />
                    {/* <AddPolygon newbound={bound} /> */}
                    <button
                      type="button"
                       disabled={DisableField || !isActive}
                      onClick={handleUploadClick}
                      className="bg-white z-[500] absolute top-3 left-14 p-2 rounded shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <LuUpload size={20} />
                    </button>

                    {showTools && isActive && (
                      <FeatureGroup ref={polygonFunctionalityRef}>
                        <EditControl
                          position="topleft"
                          onCreated={handleCreated}
                          draw={{
                            rectangle: {
                              shapeOptions: drawOptions.rectangle.shapeOptions,
                            },
                            polyline: false,
                            polygon: {
                              shapeOptions: drawOptions.polygon.shapeOptions,
                            },
                            circle: false,
                            circlemarker: false,
                            marker: false,
                          }}
                        />
                      </FeatureGroup>
                    )}
                  </MapContainer>
                </div>
                {showSidebar && isActive && (
                  <AreaDetailsSidebar
                    setSelector={setOpenImgSelecter}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    area={areaDetails}
                    ref={fieldOptionsRef}
                  />
                )}
              </div>
            </div>
            <Modal
              message={toastMsg.message}
              onClose={handleCloseToast}
              type={toastMsg.type}
              isShown={toastMsg.isShown}
            />
            <div className={`${openImgSelecter ? "block" : "hidden"}`}>
              <UploadImg setOpenImgSelecter={setOpenImgSelecter} />
            </div>
          </div>

        </FieldProvider>
      </GeoJsonProvider>

    </>
  );
};
// 📌 Function to smoothly move the map to the user's location
const RecenterMap = ({ location }) => {
  const map = useMap();
  const hasFlown = useRef(false); // Track if flyTo has been called once

  useEffect(() => {
    if (location && !hasFlown.current) {
      map.flyTo(location, 15, { duration: 2.5 });
      hasFlown.current = true; // Mark as flown so it doesn't run again
    }
  }, [location, map]);

  return null;
};
export default MapSelectorPage;